
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vfu",
      function () {
        return require("private-next-pages/vfu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vfu"])
      });
    }
  